import { SkeletonTable } from '@optools/components/loading/skeleton-table';
import { Skeleton } from '@optools/components/ui/skeleton';

export function AuditTableSkeleton() {
  return (
    <div className="p-2" data-testid="audit-table-skeleton">
      <div className="mb-4 flex items-center gap-2">
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={index} className="h-6 w-24" />
        ))}
      </div>
      <SkeletonTable columns={7} rows={10} />
    </div>
  );
}
